import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AccountStat } from './accounts-information.models';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';


@Component({
  selector: 'app-account-stat-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="p-3 sm:p-4 md:p-5 rounded-2xl border transition-all duration-300 group hover:shadow-subtle hover:-translate-y-0.5 flex flex-col justify-between h-full antialiased min-w-0"
      [ngClass]="
        stat.containerClass || 'bg-surface-elevated border-border-subtle'
      "
    >
      <div
        class="text-[9px] sm:text-[10px] font-black uppercase tracking-wider sm:tracking-widest text-text-muted font-mono transition-colors group-hover:text-text-secondary truncate"
        [title]="stat.label.startsWith('accountsInformation.') ? (stat.label | translate) : stat.label"
      >
        {{ stat.label.startsWith('accountsInformation.') ? (stat.label | translate) : stat.label }}
      </div>

      <div
        class="text-lg sm:text-xl md:text-2xl font-black text-text-primary tracking-tight font-mono mt-2 sm:mt-3 flex items-baseline gap-1"
      >
        <span class="text-text-primary transition-colors duration-300 group-hover:text-primary truncate">
          {{ stat.value }}
        </span>
        <span
          class="w-1.5 h-1.5 rounded-full bg-success opacity-0 group-hover:opacity-100 transition-opacity duration-300 shrink-0"
        ></span>
      </div>
    </div>
  `,
})
export class AccountStatCardComponent {
  @Input({ required: true }) stat!: AccountStat;
}
